"use strict";

exports.__esModule = true;
var _AppRoutes = require("./AppRoutes");
Object.keys(_AppRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppRoutes[key]) return;
  exports[key] = _AppRoutes[key];
});